export default __webpack_public_path__ + "static/media/Kadbra.29ba3018.svg";